import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Step from "@frog/source/models/Step.js"
import Audiomix from "@frog/source/juice/Audiomix.js"

const LEVEL = 3

export default {
    "affiliation": "good",
    "inventory": {},
    "party": {
        "units": {
            "teacher": {
                "key": "teacher",
                "name": "Teach",
                "isRecruited": true,
                "affiliation": "good",

                "jobKey": "swordcavalier",
                "jobName": "Teacher",
                "maxhealth": 100,
                "power": 40,
                "defense": 5,

                "decalImageKey": "",

                "skills": [
                    "rally",
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "TEACHER: ...",
                    ]
                },
                "imageUrl": require("@frog/source/assets/images/teach-tactics/mapsprite-teacher.png"),

                "level": 20,
            },
            "nerd": {
                "key": "nerd",
                "name": "Nerd",
                "jobName": "Student",
                "isRecruited": true,
                "affiliation": "good",

                "jobKey": "mage",

                "skills": [
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "NERD: Noo, please!",
                    ]
                },

                "portraits": {
                    "neutral": require("@frog/source/assets/images/teach-tactics/bargainbinbrigade-nerd.png"),
                },
                "imageUrl": require("@frog/source/assets/images/teach-tactics/mapsprite-nerd.png"),

                "levelingCriteria": ["killing", "attacking"],
                "maxexperience": 40,
                "levelups": {
                    "4": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "pull"},
                    ],
                    "5": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                    ],
                    "6": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                    ],
                },

                "level": LEVEL,
                "maxhealth": LEVEL * 10,
                "power": Math.max(0, 10 * (LEVEL - 3)),
                "defense": 5,
                "resistance": 10,
            },
            "punk": {
                "key": "punk",
                "name": "Punk",
                "jobName": "Student",
                "isRecruited": true,
                "affiliation": "good",

                "jobKey": "hammer",

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "PUNK: God fucking damn it.",
                    ]
                },

                "skills": [
                ],

                "portraits": {
                    "neutral": require("@frog/source/assets/images/teach-tactics/bargainbinbrigade-punk.png"),
                },
                "imageUrl": require("@frog/source/assets/images/teach-tactics/mapsprite-punk.png"),

                "levelingCriteria": ["tanking", "attacking"],
                "maxexperience": 40,
                "levelups": {
                    "4": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 80},
                        {"key": "skill", "value": "swap"},
                    ],
                    "5": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 100},
                    ],
                    "6": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 120},
                    ],
                },

                "level": LEVEL,
                "maxhealth": LEVEL * 10,
                "power": Math.max(0, 10 * (LEVEL - 3)),
                "defense": 10,
                "resistance": 5,
            },
            "goth": {
                "key": "goth",
                "name": "Goth",
                "jobName": "Brigand",
                "isRecruited": true,
                "affiliation": "good",

                "jobKey": "priest",
                "skills": [
                    "restore-health"
                ],

                "dialogue": {
                    "death": [
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        "GOTH: Ooh, you'll regret that~",
                    ]
                },

                "portraits": {
                    "neutral": require("@frog/source/assets/images/teach-tactics/bargainbinbrigade-goth.png"),
                },
                "imageUrl": require("@frog/source/assets/images/teach-tactics/mapsprite-goth.png"),

                "levelingCriteria": ["healing", "attacking"],
                "maxexperience": 40,
                "levelups": {
                    "4": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                        {"key": "skill", "value": "push"},
                    ],
                    "5": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                    ],
                    "6": [
                        {"key": "maxhealth", "value": 10},
                        {"key": "power", "value": 10},
                        {"key": "maxexperience", "value": 50},
                    ],
                },

                "level": LEVEL,
                "maxhealth": LEVEL * 10,
                "power": Math.max(0, 10 * (LEVEL - 3)),
                "defense": 5,
                "resistance": 10,
            },
        }
    },
}
